import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_FEATURES_QUERY_KEY } from '@/state/queries/features/use-get-features';
import type { Feature } from '@/types/features';

export const useDeleteFeatureMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const token = await getToken();
      await deleteFeature(id, token ?? '');
      return id;
    },
    onSuccess: async (id) => {
      queryClient.setQueryData<Feature[]>([GET_FEATURES_QUERY_KEY], (current) =>
        (current ?? []).filter((feature) => feature.id !== id),
      );
      await queryClient.invalidateQueries({ queryKey: [GET_FEATURES_QUERY_KEY] });
      // Do not block the mutation on every feature-access refetch.
      void queryClient.invalidateQueries({ queryKey: ['check-feature-access'] });
    },
  });
};

const deleteFeature = async (id: string, token: string): Promise<void> => {
  const url = `${import.meta.env.VITE_API_URL}/features/${id}`;
  await sendJSONRequest({ url, method: METHOD.DELETE, token });
};
